export default __webpack_public_path__ + "static/media/checkout-prototype.37bee9f9.webm";